module.exports = __webpack_public_path__ + "img/symbol_1.34845f72.png";